import { TwinDictionary } from '../../utils/globals/dictionary'
import { ItemCustomSelectDropDownRow } from './DropDown/types'
import { BuildCustomSelectClassProps } from './types'

export const buildCustomSelectClass = (props: BuildCustomSelectClassProps) => {
    const customSelectClass: string[] = []
    if (props.labelUp) {
        customSelectClass.push('custom_select_label_up')
    }
    if (props.opened) {
        customSelectClass.push('opened')
    }
    return customSelectClass.join(' ')
}

export const emptyExtraLineFirstSortFunction = (items: TwinDictionary, fieldName = 'name') => {
    const result: ItemCustomSelectDropDownRow[] = []
    for (const key in items) {
        const item = { value: key, text: items[key]?.[fieldName] }
        if (key === '') {
            result.unshift(item)
        } else {
            result.push(item)
        }
    }
    return result
}

export const orderSortFunction = (items: TwinDictionary, fieldName = 'name') => {
    const result = []
    for (const key in items) {
        const item = { value: key, text: items[key]?.[fieldName], ...items[key] }
        result.push(item)
    }
    result.sort((a, b) => {
        return a.order > b.order ? 1 : -1
    })
    return result
}